export default {
  currenciesAndCalendar: {
    queryCurrencies: {
      index: '序号',
      enable: '禁用',
      add: '新增',
      addCurrencies: '币种创建',
      openstatic: '启用',
      currencyCode: '币种代码',
      writeCurrencyCode: '请输入币种代码',
      currencyName: '币种名称',
      writeCurrencyName: '请输入币种名称',
      currencyDesc: '说明',
      writeCurrencyDesc: '请输入说明',
      publicRegion: '发行国家（地区）',
      writepublicRegion: '请输入发行国家（地区）',
      currencySymbol: '符号',
      writeCurrencySymbol: '请输入符号',
      isEnabled: '状态',
      selectisEnabled: '请选择状态',
      changeEditDatas: '选择要修改的数据!',
      wrongChangeDatas: '选择数据状态不正确!',
    },
    addCurrencies: {
      add: '创建',
      deletChange: '删除',
      publicRegion: '发行国家（地区）',
      goBack: '取消',
      sure: '确定',
      currencyCode: '请输入币种代码',
      currencyName: '请输入币种名称',
      addCurrencies: '币种维护',
      queryCurrencies: '币种查询',
    },
    calendarView: {
      creatNextYear: '创建下一年度日历',
      calendarYear: '年度',
      calendarQuarter: '季度',
      calendarOrder: '编号',
      periodName: '期间名称',
      detailStartDate: '起始日期',
      detailEndDate: '终止日期',
      isAdjustmentPeriod: '调整期',
    },
    creatCalendar: {
      viewCalendar: '查询日历',
    },
    searchCalendar: {
      calendarCode: '日历代码',
      writeCalendarCode: '请输入日历代码',
      calendarType: '日历类型',
      writeCalendarType: '请选择日历类型',
      calendarDesc: '日历说明',
      writeCalendarDesc: '请输入日历说明',
      initOpenYear: '初始打开年度',
      currentOpenYear: '当前打开年度',
      changeCurrentOpenYear: '请选择当前打开年度',
      addCalendar: '创建日历',
      calendarAdd: '日历创建',
      calendarView: '日历详情',
    },
    rules: {
      writeCapital: '请输入大写字母',
      writeLength: '输入内容超长',
      formatError: '格式错误',
    },
  },
};
